import { useState } from "react";
import type { ShareFile } from "../api";
import { t } from "../i18n";
import { FormDialog } from "./FormDialog";

// A file's name and description, edited by its owner in a short dialog over
// the page (FormDialog), as a template's are (byj-1wv.51.14): from its page's
// ⋯ and from its row's on /files (byj-1wv.51.17), one form for both, its name
// as long as the relay takes (RFC-054 §1). Saved, it closes; refused, it says
// why and stays open.

// Opened from a ⋯ menu, which has the focus as an item is done: FormDialog
// gives it back there as it closes.
const describeFileId = "file-describe";

/** The longest name the relay takes for a file (RFC-054 §1). */
const maxFileName = 255;

export function FileDescribe({ file, save, onClose }: {
  file: Pick<ShareFile, "name" | "description">;
  save: (patch: { name: string; description: string }) => Promise<void>;
  onClose: () => void;
}) {
  const [name, setName] = useState(file.name);
  const [description, setDescription] = useState(file.description);
  const changed = name.trim() !== "" && (name.trim() !== file.name.trim() || description.trim() !== file.description.trim());
  return (
    <FormDialog
      id={describeFileId}
      testid={describeFileId}
      title={t("files:fileEditTitle")}
      submitLabel={t("common:save")}
      canSubmit={changed}
      onSubmit={async () => {
        await save({ name: name.trim(), description: description.trim() });
        onClose();
      }}
      onClose={onClose}
    >
      <label className="field">
        {t("files:fileNameLabel")}
        <input value={name} onChange={(e) => setName(e.target.value)} maxLength={maxFileName} required />
      </label>
      <label className="field">
        {t("files:fileDescriptionLabel")}
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} maxLength={2000} />
      </label>
    </FormDialog>
  );
}
